import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function PrimaryButton({ to, href, children, testId, className = "", ...rest }) {
  const cls = `inline-flex items-center gap-2 bg-gold hover:bg-gold-deep text-navy font-semibold px-6 py-3.5 rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 ${className}`;
  if (to) return <Link to={to} data-testid={testId} className={cls} {...rest}>{children} <ArrowRight className="w-4 h-4" strokeWidth={2.5} /></Link>;
  return <button data-testid={testId} className={cls} {...rest}>{children} <ArrowRight className="w-4 h-4" strokeWidth={2.5} /></button>;
}

export function SecondaryButton({ to, children, testId, className = "" }) {
  const cls = `inline-flex items-center gap-2 border border-navy-800 text-navy-800 hover:bg-navy-800 hover:text-white font-semibold px-6 py-3.5 rounded-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy-800 focus-visible:ring-offset-2 ${className}`;
  return <Link to={to} data-testid={testId} className={cls}>{children}</Link>;
}

export function CtaBanner({
  eyebrow = "If not you, then WHO.",
  title = "The help exists. WHO makes the connection accountable.",
  primaryText = "Become a Partner",
  primaryTo = "/partners",
  secondaryText = "Contact WHO",
  secondaryTo = "/contact",
}) {
  return (
    <section className="py-24 lg:py-32" data-testid="cta-banner">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-lg bg-navy-900 text-white p-10 md:p-16 grain">
          <div className="absolute inset-0 dot-grid opacity-[0.06]" aria-hidden />
          <div className="relative max-w-3xl">
            <p className="eyebrow text-gold" data-testid="cta-eyebrow">{eyebrow}</p>
            <h2 className="mt-5 font-display text-3xl md:text-4xl lg:text-5xl font-black tracking-tight leading-[1.05]">
              {title}
            </h2>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to={primaryTo}
                data-testid="cta-primary-btn"
                className="inline-flex items-center gap-2 bg-gold hover:bg-gold-deep text-navy font-semibold px-6 py-3.5 rounded-md transition-colors"
              >
                {primaryText} <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
              </Link>
              <Link
                to={secondaryTo}
                data-testid="cta-secondary-btn"
                className="inline-flex items-center gap-2 border border-white/30 hover:border-gold hover:text-gold text-white font-semibold px-6 py-3.5 rounded-md transition-colors"
              >
                {secondaryText}
              </Link>
            </div>
          </div>
          <div className="absolute right-[-40px] top-[-40px] w-[220px] h-[220px] rounded-full border border-white/10" aria-hidden />
          <div className="absolute right-[-90px] bottom-[-90px] w-[300px] h-[300px] rounded-full border border-white/10" aria-hidden />
        </div>
      </div>
    </section>
  );
}
